/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ActiveSuspension,
  ApiErrorResponse,
  AssignedStructureTeam,
  ClassificationPositionRequest,
  LegacyAdvancementRule,
  LegacyAdvancementRuleCreateRequest,
  LegacyTournamentGroup,
  LegacyTournamentGroupCreateRequest,
  LegacyTournamentGroupSlot,
  LegacyTournamentGroupSlotCreateRequest,
  LegacyTournamentStage,
  LegacyTournamentStageCreateRequest,
  ManagedTeamResponseContract,
  MatchOperationV2CommandRequest,
  MatchOperationV2CommandResponse,
  MatchOperationV2Error,
  MatchOperationV2Event,
  MatchOperationV2Snapshot,
  MatchOperationsCommandRequest,
  MatchOperationsEvent,
  MatchOperationsEventBatchRequest,
  MatchOperationsEventIngestResponse,
  MatchOperationsState,
  MatchOperationsTimingSettings,
  MatchOperationsTimingSettingsUpdateRequest,
  MatchesListResponse,
  PublicMatchOperationV2EventPage,
  PublicMatchOperationV2Snapshot,
  PublicTournamentTeamRoster,
  TeamTournamentStatistics,
  TournamentCategory,
  TournamentClassification,
  TournamentClassificationCreateRequest,
  TournamentClassificationUpdateRequest,
  TournamentCreateRequest,
  TournamentListResponse,
  TournamentResultsResponse,
  TournamentStatistics,
  TournamentStructure,
  TournamentSummary,
  TournamentTeamRegistrationRequest,
  TournamentTeamsSummaryResponse,
  TournamentUpdateRequest,
} from '../models/index';
import {
    ActiveSuspensionFromJSON,
    ActiveSuspensionToJSON,
    ApiErrorResponseFromJSON,
    ApiErrorResponseToJSON,
    AssignedStructureTeamFromJSON,
    AssignedStructureTeamToJSON,
    ClassificationPositionRequestFromJSON,
    ClassificationPositionRequestToJSON,
    LegacyAdvancementRuleFromJSON,
    LegacyAdvancementRuleToJSON,
    LegacyAdvancementRuleCreateRequestFromJSON,
    LegacyAdvancementRuleCreateRequestToJSON,
    LegacyTournamentGroupFromJSON,
    LegacyTournamentGroupToJSON,
    LegacyTournamentGroupCreateRequestFromJSON,
    LegacyTournamentGroupCreateRequestToJSON,
    LegacyTournamentGroupSlotFromJSON,
    LegacyTournamentGroupSlotToJSON,
    LegacyTournamentGroupSlotCreateRequestFromJSON,
    LegacyTournamentGroupSlotCreateRequestToJSON,
    LegacyTournamentStageFromJSON,
    LegacyTournamentStageToJSON,
    LegacyTournamentStageCreateRequestFromJSON,
    LegacyTournamentStageCreateRequestToJSON,
    ManagedTeamResponseContractFromJSON,
    ManagedTeamResponseContractToJSON,
    MatchOperationV2CommandRequestFromJSON,
    MatchOperationV2CommandRequestToJSON,
    MatchOperationV2CommandResponseFromJSON,
    MatchOperationV2CommandResponseToJSON,
    MatchOperationV2ErrorFromJSON,
    MatchOperationV2ErrorToJSON,
    MatchOperationV2EventFromJSON,
    MatchOperationV2EventToJSON,
    MatchOperationV2SnapshotFromJSON,
    MatchOperationV2SnapshotToJSON,
    MatchOperationsCommandRequestFromJSON,
    MatchOperationsCommandRequestToJSON,
    MatchOperationsEventFromJSON,
    MatchOperationsEventToJSON,
    MatchOperationsEventBatchRequestFromJSON,
    MatchOperationsEventBatchRequestToJSON,
    MatchOperationsEventIngestResponseFromJSON,
    MatchOperationsEventIngestResponseToJSON,
    MatchOperationsStateFromJSON,
    MatchOperationsStateToJSON,
    MatchOperationsTimingSettingsFromJSON,
    MatchOperationsTimingSettingsToJSON,
    MatchOperationsTimingSettingsUpdateRequestFromJSON,
    MatchOperationsTimingSettingsUpdateRequestToJSON,
    MatchesListResponseFromJSON,
    MatchesListResponseToJSON,
    PublicMatchOperationV2EventPageFromJSON,
    PublicMatchOperationV2EventPageToJSON,
    PublicMatchOperationV2SnapshotFromJSON,
    PublicMatchOperationV2SnapshotToJSON,
    PublicTournamentTeamRosterFromJSON,
    PublicTournamentTeamRosterToJSON,
    TeamTournamentStatisticsFromJSON,
    TeamTournamentStatisticsToJSON,
    TournamentCategoryFromJSON,
    TournamentCategoryToJSON,
    TournamentClassificationFromJSON,
    TournamentClassificationToJSON,
    TournamentClassificationCreateRequestFromJSON,
    TournamentClassificationCreateRequestToJSON,
    TournamentClassificationUpdateRequestFromJSON,
    TournamentClassificationUpdateRequestToJSON,
    TournamentCreateRequestFromJSON,
    TournamentCreateRequestToJSON,
    TournamentListResponseFromJSON,
    TournamentListResponseToJSON,
    TournamentResultsResponseFromJSON,
    TournamentResultsResponseToJSON,
    TournamentStatisticsFromJSON,
    TournamentStatisticsToJSON,
    TournamentStructureFromJSON,
    TournamentStructureToJSON,
    TournamentSummaryFromJSON,
    TournamentSummaryToJSON,
    TournamentTeamRegistrationRequestFromJSON,
    TournamentTeamRegistrationRequestToJSON,
    TournamentTeamsSummaryResponseFromJSON,
    TournamentTeamsSummaryResponseToJSON,
    TournamentUpdateRequestFromJSON,
    TournamentUpdateRequestToJSON,
} from '../models/index';

export interface AppendMatchOperationsEventsRequest {
    id: string;
    matchOperationsEventBatchRequest: MatchOperationsEventBatchRequest;
}

export interface CreateAdvancementRuleRequest {
    legacyAdvancementRuleCreateRequest: LegacyAdvancementRuleCreateRequest;
}

export interface CreateCategoryStageRequest {
    categoryId: string;
    legacyTournamentStageCreateRequest: LegacyTournamentStageCreateRequest;
}

export interface CreateStageGroupRequest {
    stageId: string;
    legacyTournamentGroupCreateRequest: LegacyTournamentGroupCreateRequest;
}

export interface CreateStageGroupSlotRequest {
    stageId: string;
    groupId: string;
    legacyTournamentGroupSlotCreateRequest: LegacyTournamentGroupSlotCreateRequest;
}

export interface CreateTournamentRequest {
    tournamentCreateRequest: TournamentCreateRequest;
}

export interface CreateTournamentClassificationRequest {
    id: string;
    tournamentClassificationCreateRequest: TournamentClassificationCreateRequest;
}

export interface DeleteAdvancementRuleRequest {
    ruleId: string;
}

export interface DeleteGroupRequest {
    groupId: string;
}

export interface DeleteSlotRequest {
    slotId: string;
}

export interface DeleteStageRequest {
    stageId: string;
}

export interface DeleteTournamentClassificationRequest {
    id: string;
    classificationId: string;
}

export interface GetAdvancementRulesRequest {
    categoryId: string;
}

export interface GetCategoryStagesRequest {
    categoryId: string;
}

export interface GetGroupTeamsRequest {
    groupId: string;
}

export interface GetMatchOperationSnapshotV2Request {
    id: string;
}

export interface GetMatchOperationsActiveSuspensionsRequest {
    id: string;
}

export interface GetMatchOperationsEventsRequest {
    id: string;
    sinceSeq?: number;
    sinceTime?: Date;
    afterRevision?: number;
    limit?: number;
}

export interface GetMatchOperationsFeedRequest {
    id: string;
    sinceSeq?: number;
    afterRevision?: number;
    lastEventID?: string;
}

export interface GetMatchOperationsSettingsRequest {
    id: string;
}

export interface GetMatchOperationsStateRequest {
    id: string;
}

export interface GetPublicMatchOperationEventsV2Request {
    id: string;
    afterRevision?: number;
    limit?: number;
}

export interface GetPublicMatchOperationFeedV2Request {
    id: string;
    afterRevision?: number;
    lastEventID?: string;
}

export interface GetPublicMatchOperationSnapshotV2Request {
    id: string;
}

export interface GetPublicTournamentTeamRosterRequest {
    id: string;
    teamId: string;
}

export interface GetStageGroupSlotsRequest {
    stageId: string;
    groupId: string;
}

export interface GetStageGroupsRequest {
    stageId: string;
}

export interface GetTeamTournamentStatisticsRequest {
    id: string;
    teamId: string;
}

export interface GetTournamentByIdRequest {
    id: string;
}

export interface GetTournamentCategoriesRequest {
    id: string;
}

export interface GetTournamentClassificationsRequest {
    id: string;
}

export interface GetTournamentResultsSummaryRequest {
    id: string;
}

export interface GetTournamentScheduleSummaryRequest {
    id: string;
}

export interface GetTournamentStatisticsRequest {
    id: string;
    categoryId?: string;
}

export interface GetTournamentStructureSummaryRequest {
    id: string;
}

export interface GetTournamentTeamsSummaryRequest {
    id: string;
}

export interface RegisterTeamInTournamentRequest {
    id: string;
    tournamentTeamRegistrationRequest: TournamentTeamRegistrationRequest;
}

export interface SendMatchOperationsCommandRequest {
    id: string;
    matchOperationsCommandRequest: MatchOperationsCommandRequest;
}

export interface SetClassificationPositionRequest {
    id: string;
    classificationId: string;
    classificationPositionRequest: ClassificationPositionRequest;
}

export interface SetGroupTeamsRequest {
    groupId: string;
    requestBody: Array<string>;
}

export interface UpdateMatchOperationsSettingsRequest {
    id: string;
    matchOperationsTimingSettingsUpdateRequest: MatchOperationsTimingSettingsUpdateRequest;
}

export interface UpdateTournamentRequest {
    id: string;
    tournamentUpdateRequest: TournamentUpdateRequest;
}

export interface UpdateTournamentClassificationRequest {
    id: string;
    classificationId: string;
    tournamentClassificationUpdateRequest: TournamentClassificationUpdateRequest;
}

/**
 * TournamentsApi - interface
 * 
 * @export
 * @interface TournamentsApiInterface
 */
export interface TournamentsApiInterface {
    /**
     * 
     * @summary Append match operations event log entries
     * @param {string} id 
     * @param {MatchOperationsEventBatchRequest} matchOperationsEventBatchRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    appendMatchOperationsEventsRaw(requestParameters: AppendMatchOperationsEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MatchOperationsEventIngestResponse>>;

    /**
     * Append match operations event log entries
     */
    appendMatchOperationsEvents(requestParameters: AppendMatchOperationsEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MatchOperationsEventIngestResponse>;

    /**
     * 
     * @summary Create editable advancement rule in a category draft
     * @param {LegacyAdvancementRuleCreateRequest} legacyAdvancementRuleCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    createAdvancementRuleRaw(requestParameters: CreateAdvancementRuleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LegacyAdvancementRule>>;

    /**
     * Create editable advancement rule in a category draft
     */
    createAdvancementRule(requestParameters: CreateAdvancementRuleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LegacyAdvancementRule>;

    /**
     * 
     * @summary Create editable stage in a category draft
     * @param {string} categoryId 
     * @param {LegacyTournamentStageCreateRequest} legacyTournamentStageCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    createCategoryStageRaw(requestParameters: CreateCategoryStageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LegacyTournamentStage>>;

    /**
     * Create editable stage in a category draft
     */
    createCategoryStage(requestParameters: CreateCategoryStageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LegacyTournamentStage>;

    /**
     * 
     * @summary Create editable group in a stage draft
     * @param {string} stageId 
     * @param {LegacyTournamentGroupCreateRequest} legacyTournamentGroupCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    createStageGroupRaw(requestParameters: CreateStageGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LegacyTournamentGroup>>;

    /**
     * Create editable group in a stage draft
     */
    createStageGroup(requestParameters: CreateStageGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LegacyTournamentGroup>;

    /**
     * 
     * @summary Create editable advancement slot in a draft group
     * @param {string} stageId 
     * @param {string} groupId 
     * @param {LegacyTournamentGroupSlotCreateRequest} legacyTournamentGroupSlotCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    createStageGroupSlotRaw(requestParameters: CreateStageGroupSlotRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LegacyTournamentGroupSlot>>;

    /**
     * Create editable advancement slot in a draft group
     */
    createStageGroupSlot(requestParameters: CreateStageGroupSlotRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LegacyTournamentGroupSlot>;

    /**
     * 
     * @param {TournamentCreateRequest} tournamentCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    createTournamentRaw(requestParameters: CreateTournamentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TournamentSummary>>;

    /**
     */
    createTournament(requestParameters: CreateTournamentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TournamentSummary>;

    /**
     * 
     * @summary Create tournament classification
     * @param {string} id 
     * @param {TournamentClassificationCreateRequest} tournamentClassificationCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    createTournamentClassificationRaw(requestParameters: CreateTournamentClassificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TournamentClassification>>;

    /**
     * Create tournament classification
     */
    createTournamentClassification(requestParameters: CreateTournamentClassificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TournamentClassification>;

    /**
     * 
     * @summary Delete editable advancement rule from a category draft
     * @param {string} ruleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    deleteAdvancementRuleRaw(requestParameters: DeleteAdvancementRuleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Delete editable advancement rule from a category draft
     */
    deleteAdvancementRule(requestParameters: DeleteAdvancementRuleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Delete editable group from a stage draft
     * @param {string} groupId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    deleteGroupRaw(requestParameters: DeleteGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Delete editable group from a stage draft
     */
    deleteGroup(requestParameters: DeleteGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Delete editable advancement slot from a draft group
     * @param {string} slotId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    deleteSlotRaw(requestParameters: DeleteSlotRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Delete editable advancement slot from a draft group
     */
    deleteSlot(requestParameters: DeleteSlotRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Delete editable stage from a category draft
     * @param {string} stageId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    deleteStageRaw(requestParameters: DeleteStageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Delete editable stage from a category draft
     */
    deleteStage(requestParameters: DeleteStageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Delete tournament classification
     * @param {string} id 
     * @param {string} classificationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    deleteTournamentClassificationRaw(requestParameters: DeleteTournamentClassificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Delete tournament classification
     */
    deleteTournamentClassification(requestParameters: DeleteTournamentClassificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary List editable advancement rules for a category draft
     * @param {string} categoryId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    getAdvancementRulesRaw(requestParameters: GetAdvancementRulesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<LegacyAdvancementRule>>>;

    /**
     * List editable advancement rules for a category draft
     */
    getAdvancementRules(requestParameters: GetAdvancementRulesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<LegacyAdvancementRule>>;

    /**
     * 
     * @summary List editable stages for a category draft
     * @param {string} categoryId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    getCategoryStagesRaw(requestParameters: GetCategoryStagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<LegacyTournamentStage>>>;

    /**
     * List editable stages for a category draft
     */
    getCategoryStages(requestParameters: GetCategoryStagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<LegacyTournamentStage>>;

    /**
     * 
     * @summary List assigned teams for a draft group
     * @param {string} groupId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    getGroupTeamsRaw(requestParameters: GetGroupTeamsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AssignedStructureTeam>>>;

    /**
     * List assigned teams for a draft group
     */
    getGroupTeams(requestParameters: GetGroupTeamsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AssignedStructureTeam>>;

    /**
     * 
     * @summary Get the authoritative versioned match operation snapshot
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    getMatchOperationSnapshotV2Raw(requestParameters: GetMatchOperationSnapshotV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MatchOperationV2Snapshot>>;

    /**
     * Get the authoritative versioned match operation snapshot
     */
    getMatchOperationSnapshotV2(requestParameters: GetMatchOperationSnapshotV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MatchOperationV2Snapshot>;

    /**
     * 
     * @summary Get active match suspensions derived from authoritative time
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    getMatchOperationsActiveSuspensionsRaw(requestParameters: GetMatchOperationsActiveSuspensionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ActiveSuspension>>>;

    /**
     * Get active match suspensions derived from authoritative time
     */
    getMatchOperationsActiveSuspensions(requestParameters: GetMatchOperationsActiveSuspensionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ActiveSuspension>>;

    /**
     * 
     * @summary Get match operations event log entries
     * @param {string} id 
     * @param {number} [sinceSeq] 
     * @param {Date} [sinceTime] 
     * @param {number} [afterRevision] V2 durable stream cursor; use with the V2 response media type
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    getMatchOperationsEventsRaw(requestParameters: GetMatchOperationsEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<MatchOperationsEvent>>>;

    /**
     * Get match operations event log entries
     */
    getMatchOperationsEvents(requestParameters: GetMatchOperationsEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<MatchOperationsEvent>>;

    /**
     * 
     * @summary Subscribe to the live match operations SSE feed
     * @param {string} id 
     * @param {number} [sinceSeq] Legacy cursor used by application/json clients.
     * @param {number} [afterRevision] Canonical 64-bit event revision cursor. Supplying it selects the V2 recoverable feed.
     * @param {string} [lastEventID] Last V2 revision received from SSE; used when afterRevision is omitted.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    getMatchOperationsFeedRaw(requestParameters: GetMatchOperationsFeedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>>;

    /**
     * Subscribe to the live match operations SSE feed
     */
    getMatchOperationsFeed(requestParameters: GetMatchOperationsFeedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string>;

    /**
     * 
     * @summary Get effective timing settings for live match operations
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    getMatchOperationsSettingsRaw(requestParameters: GetMatchOperationsSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MatchOperationsTimingSettings>>;

    /**
     * Get effective timing settings for live match operations
     */
    getMatchOperationsSettings(requestParameters: GetMatchOperationsSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MatchOperationsTimingSettings>;

    /**
     * 
     * @summary Get authoritative live match operations state
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    getMatchOperationsStateRaw(requestParameters: GetMatchOperationsStateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MatchOperationsState>>;

    /**
     * Get authoritative live match operations state
     */
    getMatchOperationsState(requestParameters: GetMatchOperationsStateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MatchOperationsState>;

    /**
     * 
     * @summary Get an allowlisted page of public match events by canonical revision
     * @param {string} id 
     * @param {number} [afterRevision] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    getPublicMatchOperationEventsV2Raw(requestParameters: GetPublicMatchOperationEventsV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PublicMatchOperationV2EventPage>>;

    /**
     * Get an allowlisted page of public match events by canonical revision
     */
    getPublicMatchOperationEventsV2(requestParameters: GetPublicMatchOperationEventsV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PublicMatchOperationV2EventPage>;

    /**
     * 
     * @summary Subscribe to the recoverable allowlisted public match operation feed
     * @param {string} id 
     * @param {number} [afterRevision] 
     * @param {string} [lastEventID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    getPublicMatchOperationFeedV2Raw(requestParameters: GetPublicMatchOperationFeedV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>>;

    /**
     * Subscribe to the recoverable allowlisted public match operation feed
     */
    getPublicMatchOperationFeedV2(requestParameters: GetPublicMatchOperationFeedV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string>;

    /**
     * 
     * @summary Get the allowlisted public versioned match operation snapshot
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    getPublicMatchOperationSnapshotV2Raw(requestParameters: GetPublicMatchOperationSnapshotV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PublicMatchOperationV2Snapshot>>;

    /**
     * Get the allowlisted public versioned match operation snapshot
     */
    getPublicMatchOperationSnapshotV2(requestParameters: GetPublicMatchOperationSnapshotV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PublicMatchOperationV2Snapshot>;

    /**
     * 
     * @summary Get the public active player roster independently of matches and statistics
     * @param {string} id 
     * @param {string} teamId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    getPublicTournamentTeamRosterRaw(requestParameters: GetPublicTournamentTeamRosterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PublicTournamentTeamRoster>>;

    /**
     * Get the public active player roster independently of matches and statistics
     */
    getPublicTournamentTeamRoster(requestParameters: GetPublicTournamentTeamRosterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PublicTournamentTeamRoster>;

    /**
     * 
     * @summary List editable advancement slots for a draft group
     * @param {string} stageId 
     * @param {string} groupId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    getStageGroupSlotsRaw(requestParameters: GetStageGroupSlotsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<LegacyTournamentGroupSlot>>>;

    /**
     * List editable advancement slots for a draft group
     */
    getStageGroupSlots(requestParameters: GetStageGroupSlotsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<LegacyTournamentGroupSlot>>;

    /**
     * 
     * @summary List editable groups for a stage draft
     * @param {string} stageId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    getStageGroupsRaw(requestParameters: GetStageGroupsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<LegacyTournamentGroup>>>;

    /**
     * List editable groups for a stage draft
     */
    getStageGroups(requestParameters: GetStageGroupsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<LegacyTournamentGroup>>;

    /**
     * 
     * @summary Get team tournament statistics
     * @param {string} id 
     * @param {string} teamId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    getTeamTournamentStatisticsRaw(requestParameters: GetTeamTournamentStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TeamTournamentStatistics>>;

    /**
     * Get team tournament statistics
     */
    getTeamTournamentStatistics(requestParameters: GetTeamTournamentStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TeamTournamentStatistics>;

    /**
     * 
     * @summary Get tournament by id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    getTournamentByIdRaw(requestParameters: GetTournamentByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TournamentSummary>>;

    /**
     * Get tournament by id
     */
    getTournamentById(requestParameters: GetTournamentByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TournamentSummary>;

    /**
     * 
     * @summary List tournament categories
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    getTournamentCategoriesRaw(requestParameters: GetTournamentCategoriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<TournamentCategory>>>;

    /**
     * List tournament categories
     */
    getTournamentCategories(requestParameters: GetTournamentCategoriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<TournamentCategory>>;

    /**
     * 
     * @summary Get tournament classifications
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    getTournamentClassificationsRaw(requestParameters: GetTournamentClassificationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<TournamentClassification>>>;

    /**
     * Get tournament classifications
     */
    getTournamentClassifications(requestParameters: GetTournamentClassificationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<TournamentClassification>>;

    /**
     * 
     * @summary Get tournament results summary
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    getTournamentResultsSummaryRaw(requestParameters: GetTournamentResultsSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TournamentResultsResponse>>;

    /**
     * Get tournament results summary
     */
    getTournamentResultsSummary(requestParameters: GetTournamentResultsSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TournamentResultsResponse>;

    /**
     * 
     * @summary Get tournament schedule summary
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    getTournamentScheduleSummaryRaw(requestParameters: GetTournamentScheduleSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MatchesListResponse>>;

    /**
     * Get tournament schedule summary
     */
    getTournamentScheduleSummary(requestParameters: GetTournamentScheduleSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MatchesListResponse>;

    /**
     * 
     * @summary Get tournament statistics
     * @param {string} id 
     * @param {string} [categoryId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    getTournamentStatisticsRaw(requestParameters: GetTournamentStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TournamentStatistics>>;

    /**
     * Get tournament statistics
     */
    getTournamentStatistics(requestParameters: GetTournamentStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TournamentStatistics>;

    /**
     * 
     * @summary Get tournament structure summary
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    getTournamentStructureSummaryRaw(requestParameters: GetTournamentStructureSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TournamentStructure>>;

    /**
     * Get tournament structure summary
     */
    getTournamentStructureSummary(requestParameters: GetTournamentStructureSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TournamentStructure>;

    /**
     * 
     * @summary Get tournament teams summary
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    getTournamentTeamsSummaryRaw(requestParameters: GetTournamentTeamsSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TournamentTeamsSummaryResponse>>;

    /**
     * Get tournament teams summary
     */
    getTournamentTeamsSummary(requestParameters: GetTournamentTeamsSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TournamentTeamsSummaryResponse>;

    /**
     * 
     * @summary List tournaments
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    getTournamentsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TournamentListResponse>>;

    /**
     * List tournaments
     */
    getTournaments(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TournamentListResponse>;

    /**
     * 
     * @summary Register a managed team and its roster in a tournament category
     * @param {string} id 
     * @param {TournamentTeamRegistrationRequest} tournamentTeamRegistrationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    registerTeamInTournamentRaw(requestParameters: RegisterTeamInTournamentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ManagedTeamResponseContract>>;

    /**
     * Register a managed team and its roster in a tournament category
     */
    registerTeamInTournament(requestParameters: RegisterTeamInTournamentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ManagedTeamResponseContract>;

    /**
     * 
     * @summary Send a match operations command
     * @param {string} id 
     * @param {MatchOperationsCommandRequest} matchOperationsCommandRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    sendMatchOperationsCommandRaw(requestParameters: SendMatchOperationsCommandRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MatchOperationsState>>;

    /**
     * Send a match operations command
     */
    sendMatchOperationsCommand(requestParameters: SendMatchOperationsCommandRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MatchOperationsState>;

    /**
     * 
     * @summary Set tournament classification position
     * @param {string} id 
     * @param {string} classificationId 
     * @param {ClassificationPositionRequest} classificationPositionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    setClassificationPositionRaw(requestParameters: SetClassificationPositionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TournamentClassification>>;

    /**
     * Set tournament classification position
     */
    setClassificationPosition(requestParameters: SetClassificationPositionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TournamentClassification>;

    /**
     * 
     * @summary Replace assigned teams for a draft group
     * @param {string} groupId 
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    setGroupTeamsRaw(requestParameters: SetGroupTeamsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AssignedStructureTeam>>>;

    /**
     * Replace assigned teams for a draft group
     */
    setGroupTeams(requestParameters: SetGroupTeamsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AssignedStructureTeam>>;

    /**
     * 
     * @summary Update effective timing settings for live match operations
     * @param {string} id 
     * @param {MatchOperationsTimingSettingsUpdateRequest} matchOperationsTimingSettingsUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    updateMatchOperationsSettingsRaw(requestParameters: UpdateMatchOperationsSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MatchOperationsTimingSettings>>;

    /**
     * Update effective timing settings for live match operations
     */
    updateMatchOperationsSettings(requestParameters: UpdateMatchOperationsSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MatchOperationsTimingSettings>;

    /**
     * 
     * @param {string} id 
     * @param {TournamentUpdateRequest} tournamentUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    updateTournamentRaw(requestParameters: UpdateTournamentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TournamentSummary>>;

    /**
     */
    updateTournament(requestParameters: UpdateTournamentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TournamentSummary>;

    /**
     * 
     * @summary Update tournament classification
     * @param {string} id 
     * @param {string} classificationId 
     * @param {TournamentClassificationUpdateRequest} tournamentClassificationUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TournamentsApiInterface
     */
    updateTournamentClassificationRaw(requestParameters: UpdateTournamentClassificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TournamentClassification>>;

    /**
     * Update tournament classification
     */
    updateTournamentClassification(requestParameters: UpdateTournamentClassificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TournamentClassification>;

}

/**
 * 
 */
export class TournamentsApi extends runtime.BaseAPI implements TournamentsApiInterface {

    /**
     * Append match operations event log entries
     */
    async appendMatchOperationsEventsRaw(requestParameters: AppendMatchOperationsEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MatchOperationsEventIngestResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling appendMatchOperationsEvents().'
            );
        }

        if (requestParameters['matchOperationsEventBatchRequest'] == null) {
            throw new runtime.RequiredError(
                'matchOperationsEventBatchRequest',
                'Required parameter "matchOperationsEventBatchRequest" was null or undefined when calling appendMatchOperationsEvents().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/matches/{id}/operations/events`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MatchOperationsEventBatchRequestToJSON(requestParameters['matchOperationsEventBatchRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MatchOperationsEventIngestResponseFromJSON(jsonValue));
    }

    /**
     * Append match operations event log entries
     */
    async appendMatchOperationsEvents(requestParameters: AppendMatchOperationsEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MatchOperationsEventIngestResponse> {
        const response = await this.appendMatchOperationsEventsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create editable advancement rule in a category draft
     */
    async createAdvancementRuleRaw(requestParameters: CreateAdvancementRuleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LegacyAdvancementRule>> {
        if (requestParameters['legacyAdvancementRuleCreateRequest'] == null) {
            throw new runtime.RequiredError(
                'legacyAdvancementRuleCreateRequest',
                'Required parameter "legacyAdvancementRuleCreateRequest" was null or undefined when calling createAdvancementRule().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/advancements`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LegacyAdvancementRuleCreateRequestToJSON(requestParameters['legacyAdvancementRuleCreateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LegacyAdvancementRuleFromJSON(jsonValue));
    }

    /**
     * Create editable advancement rule in a category draft
     */
    async createAdvancementRule(requestParameters: CreateAdvancementRuleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LegacyAdvancementRule> {
        const response = await this.createAdvancementRuleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create editable stage in a category draft
     */
    async createCategoryStageRaw(requestParameters: CreateCategoryStageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LegacyTournamentStage>> {
        if (requestParameters['categoryId'] == null) {
            throw new runtime.RequiredError(
                'categoryId',
                'Required parameter "categoryId" was null or undefined when calling createCategoryStage().'
            );
        }

        if (requestParameters['legacyTournamentStageCreateRequest'] == null) {
            throw new runtime.RequiredError(
                'legacyTournamentStageCreateRequest',
                'Required parameter "legacyTournamentStageCreateRequest" was null or undefined when calling createCategoryStage().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/categories/{categoryId}/stages`;
        urlPath = urlPath.replace(`{${"categoryId"}}`, encodeURIComponent(String(requestParameters['categoryId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LegacyTournamentStageCreateRequestToJSON(requestParameters['legacyTournamentStageCreateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LegacyTournamentStageFromJSON(jsonValue));
    }

    /**
     * Create editable stage in a category draft
     */
    async createCategoryStage(requestParameters: CreateCategoryStageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LegacyTournamentStage> {
        const response = await this.createCategoryStageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create editable group in a stage draft
     */
    async createStageGroupRaw(requestParameters: CreateStageGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LegacyTournamentGroup>> {
        if (requestParameters['stageId'] == null) {
            throw new runtime.RequiredError(
                'stageId',
                'Required parameter "stageId" was null or undefined when calling createStageGroup().'
            );
        }

        if (requestParameters['legacyTournamentGroupCreateRequest'] == null) {
            throw new runtime.RequiredError(
                'legacyTournamentGroupCreateRequest',
                'Required parameter "legacyTournamentGroupCreateRequest" was null or undefined when calling createStageGroup().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/stages/{stageId}/groups`;
        urlPath = urlPath.replace(`{${"stageId"}}`, encodeURIComponent(String(requestParameters['stageId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LegacyTournamentGroupCreateRequestToJSON(requestParameters['legacyTournamentGroupCreateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LegacyTournamentGroupFromJSON(jsonValue));
    }

    /**
     * Create editable group in a stage draft
     */
    async createStageGroup(requestParameters: CreateStageGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LegacyTournamentGroup> {
        const response = await this.createStageGroupRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create editable advancement slot in a draft group
     */
    async createStageGroupSlotRaw(requestParameters: CreateStageGroupSlotRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LegacyTournamentGroupSlot>> {
        if (requestParameters['stageId'] == null) {
            throw new runtime.RequiredError(
                'stageId',
                'Required parameter "stageId" was null or undefined when calling createStageGroupSlot().'
            );
        }

        if (requestParameters['groupId'] == null) {
            throw new runtime.RequiredError(
                'groupId',
                'Required parameter "groupId" was null or undefined when calling createStageGroupSlot().'
            );
        }

        if (requestParameters['legacyTournamentGroupSlotCreateRequest'] == null) {
            throw new runtime.RequiredError(
                'legacyTournamentGroupSlotCreateRequest',
                'Required parameter "legacyTournamentGroupSlotCreateRequest" was null or undefined when calling createStageGroupSlot().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/stages/{stageId}/groups/{groupId}/slots`;
        urlPath = urlPath.replace(`{${"stageId"}}`, encodeURIComponent(String(requestParameters['stageId'])));
        urlPath = urlPath.replace(`{${"groupId"}}`, encodeURIComponent(String(requestParameters['groupId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LegacyTournamentGroupSlotCreateRequestToJSON(requestParameters['legacyTournamentGroupSlotCreateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LegacyTournamentGroupSlotFromJSON(jsonValue));
    }

    /**
     * Create editable advancement slot in a draft group
     */
    async createStageGroupSlot(requestParameters: CreateStageGroupSlotRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LegacyTournamentGroupSlot> {
        const response = await this.createStageGroupSlotRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async createTournamentRaw(requestParameters: CreateTournamentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TournamentSummary>> {
        if (requestParameters['tournamentCreateRequest'] == null) {
            throw new runtime.RequiredError(
                'tournamentCreateRequest',
                'Required parameter "tournamentCreateRequest" was null or undefined when calling createTournament().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/tournaments`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TournamentCreateRequestToJSON(requestParameters['tournamentCreateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TournamentSummaryFromJSON(jsonValue));
    }

    /**
     */
    async createTournament(requestParameters: CreateTournamentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TournamentSummary> {
        const response = await this.createTournamentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create tournament classification
     */
    async createTournamentClassificationRaw(requestParameters: CreateTournamentClassificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TournamentClassification>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling createTournamentClassification().'
            );
        }

        if (requestParameters['tournamentClassificationCreateRequest'] == null) {
            throw new runtime.RequiredError(
                'tournamentClassificationCreateRequest',
                'Required parameter "tournamentClassificationCreateRequest" was null or undefined when calling createTournamentClassification().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/tournaments/{id}/classifications`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TournamentClassificationCreateRequestToJSON(requestParameters['tournamentClassificationCreateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TournamentClassificationFromJSON(jsonValue));
    }

    /**
     * Create tournament classification
     */
    async createTournamentClassification(requestParameters: CreateTournamentClassificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TournamentClassification> {
        const response = await this.createTournamentClassificationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete editable advancement rule from a category draft
     */
    async deleteAdvancementRuleRaw(requestParameters: DeleteAdvancementRuleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['ruleId'] == null) {
            throw new runtime.RequiredError(
                'ruleId',
                'Required parameter "ruleId" was null or undefined when calling deleteAdvancementRule().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/advancements/{ruleId}`;
        urlPath = urlPath.replace(`{${"ruleId"}}`, encodeURIComponent(String(requestParameters['ruleId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete editable advancement rule from a category draft
     */
    async deleteAdvancementRule(requestParameters: DeleteAdvancementRuleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteAdvancementRuleRaw(requestParameters, initOverrides);
    }

    /**
     * Delete editable group from a stage draft
     */
    async deleteGroupRaw(requestParameters: DeleteGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['groupId'] == null) {
            throw new runtime.RequiredError(
                'groupId',
                'Required parameter "groupId" was null or undefined when calling deleteGroup().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/groups/{groupId}`;
        urlPath = urlPath.replace(`{${"groupId"}}`, encodeURIComponent(String(requestParameters['groupId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete editable group from a stage draft
     */
    async deleteGroup(requestParameters: DeleteGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteGroupRaw(requestParameters, initOverrides);
    }

    /**
     * Delete editable advancement slot from a draft group
     */
    async deleteSlotRaw(requestParameters: DeleteSlotRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['slotId'] == null) {
            throw new runtime.RequiredError(
                'slotId',
                'Required parameter "slotId" was null or undefined when calling deleteSlot().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/slots/{slotId}`;
        urlPath = urlPath.replace(`{${"slotId"}}`, encodeURIComponent(String(requestParameters['slotId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete editable advancement slot from a draft group
     */
    async deleteSlot(requestParameters: DeleteSlotRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteSlotRaw(requestParameters, initOverrides);
    }

    /**
     * Delete editable stage from a category draft
     */
    async deleteStageRaw(requestParameters: DeleteStageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['stageId'] == null) {
            throw new runtime.RequiredError(
                'stageId',
                'Required parameter "stageId" was null or undefined when calling deleteStage().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/stages/{stageId}`;
        urlPath = urlPath.replace(`{${"stageId"}}`, encodeURIComponent(String(requestParameters['stageId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete editable stage from a category draft
     */
    async deleteStage(requestParameters: DeleteStageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteStageRaw(requestParameters, initOverrides);
    }

    /**
     * Delete tournament classification
     */
    async deleteTournamentClassificationRaw(requestParameters: DeleteTournamentClassificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteTournamentClassification().'
            );
        }

        if (requestParameters['classificationId'] == null) {
            throw new runtime.RequiredError(
                'classificationId',
                'Required parameter "classificationId" was null or undefined when calling deleteTournamentClassification().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/tournaments/{id}/classifications/{classificationId}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
        urlPath = urlPath.replace(`{${"classificationId"}}`, encodeURIComponent(String(requestParameters['classificationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete tournament classification
     */
    async deleteTournamentClassification(requestParameters: DeleteTournamentClassificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteTournamentClassificationRaw(requestParameters, initOverrides);
    }

    /**
     * List editable advancement rules for a category draft
     */
    async getAdvancementRulesRaw(requestParameters: GetAdvancementRulesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<LegacyAdvancementRule>>> {
        if (requestParameters['categoryId'] == null) {
            throw new runtime.RequiredError(
                'categoryId',
                'Required parameter "categoryId" was null or undefined when calling getAdvancementRules().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['categoryId'] != null) {
            queryParameters['categoryId'] = requestParameters['categoryId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/advancements`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(LegacyAdvancementRuleFromJSON));
    }

    /**
     * List editable advancement rules for a category draft
     */
    async getAdvancementRules(requestParameters: GetAdvancementRulesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<LegacyAdvancementRule>> {
        const response = await this.getAdvancementRulesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List editable stages for a category draft
     */
    async getCategoryStagesRaw(requestParameters: GetCategoryStagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<LegacyTournamentStage>>> {
        if (requestParameters['categoryId'] == null) {
            throw new runtime.RequiredError(
                'categoryId',
                'Required parameter "categoryId" was null or undefined when calling getCategoryStages().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/categories/{categoryId}/stages`;
        urlPath = urlPath.replace(`{${"categoryId"}}`, encodeURIComponent(String(requestParameters['categoryId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(LegacyTournamentStageFromJSON));
    }

    /**
     * List editable stages for a category draft
     */
    async getCategoryStages(requestParameters: GetCategoryStagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<LegacyTournamentStage>> {
        const response = await this.getCategoryStagesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List assigned teams for a draft group
     */
    async getGroupTeamsRaw(requestParameters: GetGroupTeamsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AssignedStructureTeam>>> {
        if (requestParameters['groupId'] == null) {
            throw new runtime.RequiredError(
                'groupId',
                'Required parameter "groupId" was null or undefined when calling getGroupTeams().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/groups/{groupId}/teams`;
        urlPath = urlPath.replace(`{${"groupId"}}`, encodeURIComponent(String(requestParameters['groupId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AssignedStructureTeamFromJSON));
    }

    /**
     * List assigned teams for a draft group
     */
    async getGroupTeams(requestParameters: GetGroupTeamsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AssignedStructureTeam>> {
        const response = await this.getGroupTeamsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get the authoritative versioned match operation snapshot
     */
    async getMatchOperationSnapshotV2Raw(requestParameters: GetMatchOperationSnapshotV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MatchOperationV2Snapshot>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getMatchOperationSnapshotV2().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/matches/{id}/operations/snapshot`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MatchOperationV2SnapshotFromJSON(jsonValue));
    }

    /**
     * Get the authoritative versioned match operation snapshot
     */
    async getMatchOperationSnapshotV2(requestParameters: GetMatchOperationSnapshotV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MatchOperationV2Snapshot> {
        const response = await this.getMatchOperationSnapshotV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get active match suspensions derived from authoritative time
     */
    async getMatchOperationsActiveSuspensionsRaw(requestParameters: GetMatchOperationsActiveSuspensionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ActiveSuspension>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getMatchOperationsActiveSuspensions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/matches/{id}/operations/active-suspensions`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ActiveSuspensionFromJSON));
    }

    /**
     * Get active match suspensions derived from authoritative time
     */
    async getMatchOperationsActiveSuspensions(requestParameters: GetMatchOperationsActiveSuspensionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ActiveSuspension>> {
        const response = await this.getMatchOperationsActiveSuspensionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get match operations event log entries
     */
    async getMatchOperationsEventsRaw(requestParameters: GetMatchOperationsEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<MatchOperationsEvent>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getMatchOperationsEvents().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sinceSeq'] != null) {
            queryParameters['sinceSeq'] = requestParameters['sinceSeq'];
        }

        if (requestParameters['sinceTime'] != null) {
            queryParameters['sinceTime'] = (requestParameters['sinceTime'] as any).toISOString();
        }

        if (requestParameters['afterRevision'] != null) {
            queryParameters['afterRevision'] = requestParameters['afterRevision'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/matches/{id}/operations/events`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MatchOperationsEventFromJSON));
    }

    /**
     * Get match operations event log entries
     */
    async getMatchOperationsEvents(requestParameters: GetMatchOperationsEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<MatchOperationsEvent>> {
        const response = await this.getMatchOperationsEventsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Subscribe to the live match operations SSE feed
     */
    async getMatchOperationsFeedRaw(requestParameters: GetMatchOperationsFeedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getMatchOperationsFeed().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sinceSeq'] != null) {
            queryParameters['sinceSeq'] = requestParameters['sinceSeq'];
        }

        if (requestParameters['afterRevision'] != null) {
            queryParameters['afterRevision'] = requestParameters['afterRevision'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['lastEventID'] != null) {
            headerParameters['Last-Event-ID'] = String(requestParameters['lastEventID']);
        }


        let urlPath = `/matches/{id}/operations/feed`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Subscribe to the live match operations SSE feed
     */
    async getMatchOperationsFeed(requestParameters: GetMatchOperationsFeedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.getMatchOperationsFeedRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get effective timing settings for live match operations
     */
    async getMatchOperationsSettingsRaw(requestParameters: GetMatchOperationsSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MatchOperationsTimingSettings>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getMatchOperationsSettings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/matches/{id}/operations/settings`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MatchOperationsTimingSettingsFromJSON(jsonValue));
    }

    /**
     * Get effective timing settings for live match operations
     */
    async getMatchOperationsSettings(requestParameters: GetMatchOperationsSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MatchOperationsTimingSettings> {
        const response = await this.getMatchOperationsSettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get authoritative live match operations state
     */
    async getMatchOperationsStateRaw(requestParameters: GetMatchOperationsStateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MatchOperationsState>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getMatchOperationsState().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/matches/{id}/operations/state`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MatchOperationsStateFromJSON(jsonValue));
    }

    /**
     * Get authoritative live match operations state
     */
    async getMatchOperationsState(requestParameters: GetMatchOperationsStateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MatchOperationsState> {
        const response = await this.getMatchOperationsStateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get an allowlisted page of public match events by canonical revision
     */
    async getPublicMatchOperationEventsV2Raw(requestParameters: GetPublicMatchOperationEventsV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PublicMatchOperationV2EventPage>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getPublicMatchOperationEventsV2().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['afterRevision'] != null) {
            queryParameters['afterRevision'] = requestParameters['afterRevision'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/public/matches/{id}/operations/events`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PublicMatchOperationV2EventPageFromJSON(jsonValue));
    }

    /**
     * Get an allowlisted page of public match events by canonical revision
     */
    async getPublicMatchOperationEventsV2(requestParameters: GetPublicMatchOperationEventsV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PublicMatchOperationV2EventPage> {
        const response = await this.getPublicMatchOperationEventsV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Subscribe to the recoverable allowlisted public match operation feed
     */
    async getPublicMatchOperationFeedV2Raw(requestParameters: GetPublicMatchOperationFeedV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getPublicMatchOperationFeedV2().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['afterRevision'] != null) {
            queryParameters['afterRevision'] = requestParameters['afterRevision'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['lastEventID'] != null) {
            headerParameters['Last-Event-ID'] = String(requestParameters['lastEventID']);
        }


        let urlPath = `/public/matches/{id}/operations/feed`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Subscribe to the recoverable allowlisted public match operation feed
     */
    async getPublicMatchOperationFeedV2(requestParameters: GetPublicMatchOperationFeedV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.getPublicMatchOperationFeedV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get the allowlisted public versioned match operation snapshot
     */
    async getPublicMatchOperationSnapshotV2Raw(requestParameters: GetPublicMatchOperationSnapshotV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PublicMatchOperationV2Snapshot>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getPublicMatchOperationSnapshotV2().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/public/matches/{id}/operations/snapshot`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PublicMatchOperationV2SnapshotFromJSON(jsonValue));
    }

    /**
     * Get the allowlisted public versioned match operation snapshot
     */
    async getPublicMatchOperationSnapshotV2(requestParameters: GetPublicMatchOperationSnapshotV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PublicMatchOperationV2Snapshot> {
        const response = await this.getPublicMatchOperationSnapshotV2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get the public active player roster independently of matches and statistics
     */
    async getPublicTournamentTeamRosterRaw(requestParameters: GetPublicTournamentTeamRosterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PublicTournamentTeamRoster>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getPublicTournamentTeamRoster().'
            );
        }

        if (requestParameters['teamId'] == null) {
            throw new runtime.RequiredError(
                'teamId',
                'Required parameter "teamId" was null or undefined when calling getPublicTournamentTeamRoster().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/tournaments/{id}/teams/{teamId}/roster-summary`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
        urlPath = urlPath.replace(`{${"teamId"}}`, encodeURIComponent(String(requestParameters['teamId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PublicTournamentTeamRosterFromJSON(jsonValue));
    }

    /**
     * Get the public active player roster independently of matches and statistics
     */
    async getPublicTournamentTeamRoster(requestParameters: GetPublicTournamentTeamRosterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PublicTournamentTeamRoster> {
        const response = await this.getPublicTournamentTeamRosterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List editable advancement slots for a draft group
     */
    async getStageGroupSlotsRaw(requestParameters: GetStageGroupSlotsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<LegacyTournamentGroupSlot>>> {
        if (requestParameters['stageId'] == null) {
            throw new runtime.RequiredError(
                'stageId',
                'Required parameter "stageId" was null or undefined when calling getStageGroupSlots().'
            );
        }

        if (requestParameters['groupId'] == null) {
            throw new runtime.RequiredError(
                'groupId',
                'Required parameter "groupId" was null or undefined when calling getStageGroupSlots().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/stages/{stageId}/groups/{groupId}/slots`;
        urlPath = urlPath.replace(`{${"stageId"}}`, encodeURIComponent(String(requestParameters['stageId'])));
        urlPath = urlPath.replace(`{${"groupId"}}`, encodeURIComponent(String(requestParameters['groupId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(LegacyTournamentGroupSlotFromJSON));
    }

    /**
     * List editable advancement slots for a draft group
     */
    async getStageGroupSlots(requestParameters: GetStageGroupSlotsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<LegacyTournamentGroupSlot>> {
        const response = await this.getStageGroupSlotsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List editable groups for a stage draft
     */
    async getStageGroupsRaw(requestParameters: GetStageGroupsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<LegacyTournamentGroup>>> {
        if (requestParameters['stageId'] == null) {
            throw new runtime.RequiredError(
                'stageId',
                'Required parameter "stageId" was null or undefined when calling getStageGroups().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/stages/{stageId}/groups`;
        urlPath = urlPath.replace(`{${"stageId"}}`, encodeURIComponent(String(requestParameters['stageId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(LegacyTournamentGroupFromJSON));
    }

    /**
     * List editable groups for a stage draft
     */
    async getStageGroups(requestParameters: GetStageGroupsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<LegacyTournamentGroup>> {
        const response = await this.getStageGroupsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get team tournament statistics
     */
    async getTeamTournamentStatisticsRaw(requestParameters: GetTeamTournamentStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TeamTournamentStatistics>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getTeamTournamentStatistics().'
            );
        }

        if (requestParameters['teamId'] == null) {
            throw new runtime.RequiredError(
                'teamId',
                'Required parameter "teamId" was null or undefined when calling getTeamTournamentStatistics().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/tournaments/{id}/teams/{teamId}/statistics`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
        urlPath = urlPath.replace(`{${"teamId"}}`, encodeURIComponent(String(requestParameters['teamId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TeamTournamentStatisticsFromJSON(jsonValue));
    }

    /**
     * Get team tournament statistics
     */
    async getTeamTournamentStatistics(requestParameters: GetTeamTournamentStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TeamTournamentStatistics> {
        const response = await this.getTeamTournamentStatisticsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get tournament by id
     */
    async getTournamentByIdRaw(requestParameters: GetTournamentByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TournamentSummary>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getTournamentById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/tournaments/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TournamentSummaryFromJSON(jsonValue));
    }

    /**
     * Get tournament by id
     */
    async getTournamentById(requestParameters: GetTournamentByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TournamentSummary> {
        const response = await this.getTournamentByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List tournament categories
     */
    async getTournamentCategoriesRaw(requestParameters: GetTournamentCategoriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<TournamentCategory>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getTournamentCategories().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/tournaments/{id}/categories`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TournamentCategoryFromJSON));
    }

    /**
     * List tournament categories
     */
    async getTournamentCategories(requestParameters: GetTournamentCategoriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<TournamentCategory>> {
        const response = await this.getTournamentCategoriesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get tournament classifications
     */
    async getTournamentClassificationsRaw(requestParameters: GetTournamentClassificationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<TournamentClassification>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getTournamentClassifications().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/tournaments/{id}/classifications`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TournamentClassificationFromJSON));
    }

    /**
     * Get tournament classifications
     */
    async getTournamentClassifications(requestParameters: GetTournamentClassificationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<TournamentClassification>> {
        const response = await this.getTournamentClassificationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get tournament results summary
     */
    async getTournamentResultsSummaryRaw(requestParameters: GetTournamentResultsSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TournamentResultsResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getTournamentResultsSummary().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/tournaments/{id}/results-summary`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TournamentResultsResponseFromJSON(jsonValue));
    }

    /**
     * Get tournament results summary
     */
    async getTournamentResultsSummary(requestParameters: GetTournamentResultsSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TournamentResultsResponse> {
        const response = await this.getTournamentResultsSummaryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get tournament schedule summary
     */
    async getTournamentScheduleSummaryRaw(requestParameters: GetTournamentScheduleSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MatchesListResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getTournamentScheduleSummary().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/tournaments/{id}/schedule-summary`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MatchesListResponseFromJSON(jsonValue));
    }

    /**
     * Get tournament schedule summary
     */
    async getTournamentScheduleSummary(requestParameters: GetTournamentScheduleSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MatchesListResponse> {
        const response = await this.getTournamentScheduleSummaryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get tournament statistics
     */
    async getTournamentStatisticsRaw(requestParameters: GetTournamentStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TournamentStatistics>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getTournamentStatistics().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['categoryId'] != null) {
            queryParameters['categoryId'] = requestParameters['categoryId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/tournaments/{id}/statistics`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TournamentStatisticsFromJSON(jsonValue));
    }

    /**
     * Get tournament statistics
     */
    async getTournamentStatistics(requestParameters: GetTournamentStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TournamentStatistics> {
        const response = await this.getTournamentStatisticsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get tournament structure summary
     */
    async getTournamentStructureSummaryRaw(requestParameters: GetTournamentStructureSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TournamentStructure>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getTournamentStructureSummary().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/tournaments/{id}/structure-summary`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TournamentStructureFromJSON(jsonValue));
    }

    /**
     * Get tournament structure summary
     */
    async getTournamentStructureSummary(requestParameters: GetTournamentStructureSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TournamentStructure> {
        const response = await this.getTournamentStructureSummaryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get tournament teams summary
     */
    async getTournamentTeamsSummaryRaw(requestParameters: GetTournamentTeamsSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TournamentTeamsSummaryResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getTournamentTeamsSummary().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/tournaments/{id}/teams-summary`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TournamentTeamsSummaryResponseFromJSON(jsonValue));
    }

    /**
     * Get tournament teams summary
     */
    async getTournamentTeamsSummary(requestParameters: GetTournamentTeamsSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TournamentTeamsSummaryResponse> {
        const response = await this.getTournamentTeamsSummaryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List tournaments
     */
    async getTournamentsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TournamentListResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/tournaments`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TournamentListResponseFromJSON(jsonValue));
    }

    /**
     * List tournaments
     */
    async getTournaments(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TournamentListResponse> {
        const response = await this.getTournamentsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Register a managed team and its roster in a tournament category
     */
    async registerTeamInTournamentRaw(requestParameters: RegisterTeamInTournamentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ManagedTeamResponseContract>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling registerTeamInTournament().'
            );
        }

        if (requestParameters['tournamentTeamRegistrationRequest'] == null) {
            throw new runtime.RequiredError(
                'tournamentTeamRegistrationRequest',
                'Required parameter "tournamentTeamRegistrationRequest" was null or undefined when calling registerTeamInTournament().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/tournaments/{id}/register`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TournamentTeamRegistrationRequestToJSON(requestParameters['tournamentTeamRegistrationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ManagedTeamResponseContractFromJSON(jsonValue));
    }

    /**
     * Register a managed team and its roster in a tournament category
     */
    async registerTeamInTournament(requestParameters: RegisterTeamInTournamentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ManagedTeamResponseContract> {
        const response = await this.registerTeamInTournamentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Send a match operations command
     */
    async sendMatchOperationsCommandRaw(requestParameters: SendMatchOperationsCommandRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MatchOperationsState>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling sendMatchOperationsCommand().'
            );
        }

        if (requestParameters['matchOperationsCommandRequest'] == null) {
            throw new runtime.RequiredError(
                'matchOperationsCommandRequest',
                'Required parameter "matchOperationsCommandRequest" was null or undefined when calling sendMatchOperationsCommand().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/matches/{id}/operations/commands`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MatchOperationsCommandRequestToJSON(requestParameters['matchOperationsCommandRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MatchOperationsStateFromJSON(jsonValue));
    }

    /**
     * Send a match operations command
     */
    async sendMatchOperationsCommand(requestParameters: SendMatchOperationsCommandRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MatchOperationsState> {
        const response = await this.sendMatchOperationsCommandRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Set tournament classification position
     */
    async setClassificationPositionRaw(requestParameters: SetClassificationPositionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TournamentClassification>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling setClassificationPosition().'
            );
        }

        if (requestParameters['classificationId'] == null) {
            throw new runtime.RequiredError(
                'classificationId',
                'Required parameter "classificationId" was null or undefined when calling setClassificationPosition().'
            );
        }

        if (requestParameters['classificationPositionRequest'] == null) {
            throw new runtime.RequiredError(
                'classificationPositionRequest',
                'Required parameter "classificationPositionRequest" was null or undefined when calling setClassificationPosition().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/tournaments/{id}/classifications/{classificationId}/positions`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
        urlPath = urlPath.replace(`{${"classificationId"}}`, encodeURIComponent(String(requestParameters['classificationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ClassificationPositionRequestToJSON(requestParameters['classificationPositionRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TournamentClassificationFromJSON(jsonValue));
    }

    /**
     * Set tournament classification position
     */
    async setClassificationPosition(requestParameters: SetClassificationPositionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TournamentClassification> {
        const response = await this.setClassificationPositionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Replace assigned teams for a draft group
     */
    async setGroupTeamsRaw(requestParameters: SetGroupTeamsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AssignedStructureTeam>>> {
        if (requestParameters['groupId'] == null) {
            throw new runtime.RequiredError(
                'groupId',
                'Required parameter "groupId" was null or undefined when calling setGroupTeams().'
            );
        }

        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling setGroupTeams().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/groups/{groupId}/teams`;
        urlPath = urlPath.replace(`{${"groupId"}}`, encodeURIComponent(String(requestParameters['groupId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AssignedStructureTeamFromJSON));
    }

    /**
     * Replace assigned teams for a draft group
     */
    async setGroupTeams(requestParameters: SetGroupTeamsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AssignedStructureTeam>> {
        const response = await this.setGroupTeamsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update effective timing settings for live match operations
     */
    async updateMatchOperationsSettingsRaw(requestParameters: UpdateMatchOperationsSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MatchOperationsTimingSettings>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateMatchOperationsSettings().'
            );
        }

        if (requestParameters['matchOperationsTimingSettingsUpdateRequest'] == null) {
            throw new runtime.RequiredError(
                'matchOperationsTimingSettingsUpdateRequest',
                'Required parameter "matchOperationsTimingSettingsUpdateRequest" was null or undefined when calling updateMatchOperationsSettings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/matches/{id}/operations/settings`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: MatchOperationsTimingSettingsUpdateRequestToJSON(requestParameters['matchOperationsTimingSettingsUpdateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MatchOperationsTimingSettingsFromJSON(jsonValue));
    }

    /**
     * Update effective timing settings for live match operations
     */
    async updateMatchOperationsSettings(requestParameters: UpdateMatchOperationsSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MatchOperationsTimingSettings> {
        const response = await this.updateMatchOperationsSettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateTournamentRaw(requestParameters: UpdateTournamentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TournamentSummary>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateTournament().'
            );
        }

        if (requestParameters['tournamentUpdateRequest'] == null) {
            throw new runtime.RequiredError(
                'tournamentUpdateRequest',
                'Required parameter "tournamentUpdateRequest" was null or undefined when calling updateTournament().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/tournaments/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: TournamentUpdateRequestToJSON(requestParameters['tournamentUpdateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TournamentSummaryFromJSON(jsonValue));
    }

    /**
     */
    async updateTournament(requestParameters: UpdateTournamentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TournamentSummary> {
        const response = await this.updateTournamentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update tournament classification
     */
    async updateTournamentClassificationRaw(requestParameters: UpdateTournamentClassificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TournamentClassification>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateTournamentClassification().'
            );
        }

        if (requestParameters['classificationId'] == null) {
            throw new runtime.RequiredError(
                'classificationId',
                'Required parameter "classificationId" was null or undefined when calling updateTournamentClassification().'
            );
        }

        if (requestParameters['tournamentClassificationUpdateRequest'] == null) {
            throw new runtime.RequiredError(
                'tournamentClassificationUpdateRequest',
                'Required parameter "tournamentClassificationUpdateRequest" was null or undefined when calling updateTournamentClassification().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/tournaments/{id}/classifications/{classificationId}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
        urlPath = urlPath.replace(`{${"classificationId"}}`, encodeURIComponent(String(requestParameters['classificationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: TournamentClassificationUpdateRequestToJSON(requestParameters['tournamentClassificationUpdateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TournamentClassificationFromJSON(jsonValue));
    }

    /**
     * Update tournament classification
     */
    async updateTournamentClassification(requestParameters: UpdateTournamentClassificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TournamentClassification> {
        const response = await this.updateTournamentClassificationRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
